export default __webpack_public_path__ + "dfb556f8ce4e22ef5b66a650bdb8e155.svg";